export default __webpack_public_path__ + "static/Entenda0086-75c7c4a0e99e86298636ed281fcd1931.jpg";